import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ5CompD: IAbstractModule = {
    type: IModuleType.Z5comp,
    name: 'Z 5 compartment D',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 5,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 5,
                accessible: false,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 3,
                accessible: true,
            },
            {
                name: "4",
                connector: "4",
                cell_size_id: 5,
                accessible: true,
            },
            {
                name: "5",
                connector: "5",
                cell_size_id: 5,
                accessible: false,
            },
        ]
    ]
}